import Api from '../../services/api_'

class Service extends Api { }

export default new Service('colaboradores')